import {  convertToZonedTimestamp, generateZonedTimestamp, getZonedStartOfDay } from "common/helpers/dateAndTimeHelpersV2";
import { DateRangeProps } from "../";

export interface DefaultRangeReturnProps {
    today: DateRangeProps;
    yesterday: DateRangeProps;
    //'this week': DateRangeProps;
    //'last week': DateRangeProps;
    //'last 2 weeks': DateRangeProps;
    //'this month': DateRangeProps;
    //'last 30 days': DateRangeV2Props;
    //'last 60 days': DateRangeV2Props;
}
// this has to be local format if we're disabling auto click
export const defaultRangeProps = (timeZone = 'UTC'): DefaultRangeReturnProps => {
 
  
  const dayStartDate = getZonedStartOfDay(timeZone).date.getTime()
  const weekStartDate = generateZonedTimestamp(timeZone, { startOf: `week` }).date.getTime()
  const monthStartDate = generateZonedTimestamp(timeZone, { startOf: `month` }).date.getTime()
  const now = generateZonedTimestamp(timeZone, {}).date.getTime()

  const newDates = {
    today: {
      label: 'today',
      startTime: dayStartDate,
      endTime: now
    },
    yesterday: {
      label: 'yesterday',
      startTime: dayStartDate - 86400000,
      endTime: dayStartDate - 86400000
    },
    'last 3 days': {
      label: 'last 3 days',
      startTime: dayStartDate - (86400000 * 2),
      endTime: now
    },
    'last 7 days': {
      label: 'last 7 days',
      startTime: dayStartDate - (86400000 * 6),
      endTime: now
    },
    'this week': {
      label: 'this week',
      startTime: weekStartDate,
      endTime: now
    },
    'last 2 weeks': {
      label: 'last 2 weeks',
      startTime: weekStartDate - (86400000 * 7),
      endTime: now
    },
    'last week': {
      label: 'last week',
      startTime: weekStartDate - (86400000 * 7),
      endTime: weekStartDate - 86400000
    },
    'this month': {
      label: 'this month',
      startTime: monthStartDate,
      endTime: now
    },
    'last 30 days': {
      label: 'last 30 days',
      startTime: dayStartDate - (86400000 * 30) - 86400000,
      endTime: now
    },
    'last 60 days': {
      label: 'last 60 days',
      startTime: dayStartDate - (86400000 * 60) - 86400000,
      endTime: now
    },
    'last 90 days': {
      label: 'last 90 days',
      startTime: dayStartDate - (86400000 * 90) - 86400000,
      endTime: now
    },
    'last 180 days': {
      label: 'last 180 days',
      startTime: dayStartDate - (86400000 * 180) - 86400000,
      endTime: now
    },
    'last 365 days': {
      label: 'last 365 days',
      startTime: dayStartDate - (86400000 * 365) - 86400000,
      endTime: now
    }
  }
 
 
  return newDates
}